"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGenerateId = exports.globalSheetsRegistry = exports.globalJss = exports.createSheetsRegistry = exports.createJss = exports.useTheme = exports.withTheme = exports.JssThemeProvider = exports.theming = exports.ThemeProviderContext = exports.ThemeContext = exports.RAMBLER_UI_DISPLAY_NAME_PREFIX = exports.RAMBLER_UI_CLASS_NAME_PREFIX = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = require("react");

var _jss = _interopRequireWildcard(require("jss"));

var _reactJss = require("react-jss");

var _jssPresetDefault = _interopRequireDefault(require("jss-preset-default"));

var RAMBLER_UI_CLASS_NAME_PREFIX = 'rui-';
exports.RAMBLER_UI_CLASS_NAME_PREFIX = RAMBLER_UI_CLASS_NAME_PREFIX;
var RAMBLER_UI_DISPLAY_NAME_PREFIX = '__RAMBLER_UI_DISPLAY_NAME_PREFIX__';
exports.RAMBLER_UI_DISPLAY_NAME_PREFIX = RAMBLER_UI_DISPLAY_NAME_PREFIX;
var ThemeContext = (0, _react.createContext)({});
exports.ThemeContext = ThemeContext;
var ThemeProviderContext = (0, _react.createContext)({});
exports.ThemeProviderContext = ThemeProviderContext;
var theming = (0, _reactJss.createTheming)(ThemeContext);
exports.theming = theming;
var JssThemeProvider = theming.ThemeProvider,
    withTheme = theming.withTheme,
    useTheme = theming.useTheme;
exports.useTheme = useTheme;
exports.withTheme = withTheme;
exports.JssThemeProvider = JssThemeProvider;

var createJss = function createJss() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _jss.create)((0, _extends2.default)({}, (0, _jssPresetDefault.default)(options), {}, options));
};

exports.createJss = createJss;

var createSheetsRegistry = function createSheetsRegistry() {
  return new _reactJss.SheetsRegistry();
};

exports.createSheetsRegistry = createSheetsRegistry;
var globalJss = createJss();
exports.globalJss = globalJss;
var globalSheetsRegistry = createSheetsRegistry();
exports.globalSheetsRegistry = globalSheetsRegistry;

var createGenerateId = function createGenerateId() {
  var themeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var generateId = (0, _jss.createGenerateId)();
  return function (rule, sheet) {
    var displayNamePrefix = sheet ? sheet.options[RAMBLER_UI_DISPLAY_NAME_PREFIX] : '';
    if (!displayNamePrefix) return generateId(rule, sheet);
    var jssId = sheet ? sheet.options.jss.id : globalJss.id;
    var jssCounter = jssId === globalJss.id ? '' : "-".concat(jssId);
    var themeCounter = themeId === 0 ? '' : "-".concat(themeId);
    return RAMBLER_UI_CLASS_NAME_PREFIX + displayNamePrefix + rule.key + jssCounter + themeCounter;
  };
};

exports.createGenerateId = createGenerateId;

_jss.default.setup({
  createGenerateId: createGenerateId
});